import React from 'react';
import { QUOTING, START } from 'shared/data/quoteSteps';

import QuoteActionBar from 'us_pcb_assembly/components/QuoteActionBar';
import USLeadTimeRestrictions from 'shared/product_tabs/tab_assembly/components/USLeadTimeRestrictions';
import PriceMatrix from 'shared/components/price/PriceMatrix';

const PriceUS = (props) => {
  const {
    quote,
    quoteStep,
    parametersChanged,
    onPriceSelect,
    parameters,
  } = props;

  const lineItem = quote.line_items.find((i) => i.product_key === 'assembly-us');
  const { restricted_price } = lineItem;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="text-uppercase">USA PCB Assembly</h2>
        {quoteStep !== QUOTING && <QuoteActionBar />}
      </div>
      <div className="row">
        <div className="col-12">
          <PriceMatrix
            tableStripe
            lineItem={lineItem}
            parametersChanged={parametersChanged}
            onPriceSelect={onPriceSelect}
            parameters={parameters}
            quoteStep={quoteStep}
            restrictedPrice={restricted_price} />
        </div>
      </div>
      <USLeadTimeRestrictions />
    </>
  );
};

export default PriceUS;
